import { useContext } from "react";
import { CompanyAccess, PermissionScope } from "@me-team/host/main/graphql/types";
import AccessService from "@me-team/host/services/AccessService";
import { AccessContext } from "@me-team/host/src/components/App/App";
import { AllModulesTagName } from "../../utils/enums";

const warehouseTutorialRequiredModules = [AllModulesTagName.WAREHOUSES];

const warehouseTutorialRequiredPermissions = [
    CompanyAccess.ProductListView,
    CompanyAccess.ProductCreate,
    CompanyAccess.WarehouseListView,
    CompanyAccess.WarehouseProductListView,
    CompanyAccess.WarehouseProductWriteOff,
    CompanyAccess.WarehouseProductMove,
    CompanyAccess.WarehouseReportViewExport,
    CompanyAccess.WarehouseOperationListView,
    CompanyAccess.WarehouseOperationProductWriteOffEdit,
    CompanyAccess.WarehouseOperationMoveEdit,
    CompanyAccess.WarehouseOperationSaleCreate,
    CompanyAccess.WarehouseOperationSaleEdit,
    CompanyAccess.WarehouseOperationEditHistoryView,
    CompanyAccess.TechMapListView,
    CompanyAccess.TechMapCreate,
    CompanyAccess.TechMapProductListView,
    CompanyAccess.TechMapProductListEdit,
    CompanyAccess.TechMapServiceListView,
    CompanyAccess.TechMapServiceListEdit,
    CompanyAccess.ServiceListView,
    CompanyAccess.ServiceCreate,
    CompanyAccess.LogbookConsumablesWriteOff,
    CompanyAccess.BookingStatisticViewExport,
];

const warehouseProductAddPermissions = [CompanyAccess.WarehouseProductAdd, CompanyAccess.WarehouseProductCreateAndAdd];

export const onlineBookingTutorialRequiredPermissions = [
    CompanyAccess.EmployeeCreate,
    CompanyAccess.AccessManageBranchEmployees,
    CompanyAccess.ServiceListView,
    CompanyAccess.ServiceCreate,
    CompanyAccess.ServiceEmployeesView,
    CompanyAccess.ServiceEmployeesEdit,
    CompanyAccess.ServiceAndOnlineBookingEdit,
    CompanyAccess.OnlineBookingSettingsEdit,
];

export const onlineBookingTutorialRequiredAllScopePermissions = [
    CompanyAccess.EmployeeListView,
    CompanyAccess.EmployeeView,
    CompanyAccess.EmployeeEdit,
    CompanyAccess.EmployeeBookingSettingsView,
    CompanyAccess.EmployeeBookingSettingsEdit,
    CompanyAccess.ScheduleCalendarView,
    CompanyAccess.ScheduleCreate,
    CompanyAccess.ScheduleEdit,
];

export const useTutorialAccess = () => {
    const { isReady } = useContext(AccessContext);
    const accessService = AccessService.getInstance();

    const isRoleAccessPending = !isReady || !accessService.isRoleAccessReady() || accessService.isRoleAccessLoading();

    if (isRoleAccessPending) {
        return {
            canStartWarehouseTutorial: false,
            canStartOnlineBookingTutorial: false,
        };
    }

    const canStartWarehouseTutorial =
        accessService.areModulesActive(warehouseTutorialRequiredModules) &&
        accessService.hasAllPermissions(warehouseTutorialRequiredPermissions) &&
        accessService.hasAnyPermission(warehouseProductAddPermissions);

    const canStartOnlineBookingTutorial =
        accessService.hasAllPermissions(onlineBookingTutorialRequiredPermissions) &&
        onlineBookingTutorialRequiredAllScopePermissions.every((permission) =>
            accessService.hasPermission(permission, { scope: PermissionScope.All })
        );

    return {
        canStartWarehouseTutorial,
        canStartOnlineBookingTutorial,
    };
};
